import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-sorting-arrow',
  templateUrl: './sorting-arrow.component.html',
  styleUrls: ['./sorting-arrow.component.scss']
})
export class SortingArrowComponent implements OnInit {

  @Input() public direction: 'up' | 'down';

  constructor() { }

  ngOnInit() {
  }

}
